/**
 * 权限及字段可见性工具类
 */
export const auth = {
    /**
     * 判断当前登录用户是否拥有特定 url 权限（推荐用于 menuType=M 的按钮权限控制）
     * @url {string} url 后端返回的 url，例如 /my
     * @returns {boolean}
     */
    hasUrl(url) {
        if (!url) return false
        if (this.isSuperAdmin()) return true

        let menuList = localStorage.getItem("userMenuList")
        try {
            menuList = menuList ? JSON.parse(menuList) : []
        } catch (e) {
            menuList = []
        }

        const dfs = (list) => {
            for (const item of (list || [])) {
                if (item && item.menuType === 'M' && item.url === url) return true
            }
            return false
        }

        return dfs(menuList)
    },
    /**
     * 判断当前登录用户是否拥有特定 perms 权限（推荐用于 menuType=F 的按钮权限控制）
     * @param {string} perms 后端返回的 perms，例如 program:info:add
     * @returns {boolean}
     */
    hasPerms(perms) {
        if (!perms) return false
        if (this.isSuperAdmin()) return true

        let menuList = localStorage.getItem("userMenuList")
        try {
            menuList = menuList ? JSON.parse(menuList) : []
        } catch (e) {
            menuList = []
        }

        const dfs = (list) => {
            for (const item of (list || [])) {
                if (item &&  item.perms === perms) return true
                if (item && item.children && item.children.length > 0) {
                    if (dfs(item.children)) return true
                }
            }
            return false
        }

        return dfs(menuList)
    },
    /**
     * 获取当前用户等级
     * @returns {number}
     */
    getLevel() {
        return parseInt(localStorage.getItem('level'))
    },

    /**
     * 获取当前类型 1 客户  0 用户
     * @returns {number}
     */
    getUserType() {
        const  userList = localStorage.getItem("userList")
        return parseInt(userList.userType)
    },

    /**
     * 判断是否为超级管理员
     * @returns {boolean}
     */
    isSuperAdmin() {
        const  userList = localStorage.getItem("userList")
        return userList.superAdmin
    },



}

export default auth
